import React from 'react';
import './ConfirmationPage.less';
import ContinueButtonHolder from '../ButtonHolder/ContinueButtonHolder';
import backgroundImage from '../../images/cabin-blue-create-account-page.svg';
import ConfirmBrandButtonHolder from '../ButtonHolder/ConfirmBrandButtonHolder';
import {getBrandImageUrl, getFlagImageUrl, MERCHANT_OF_RECORD} from '../../utils/constants';
import {ButtonPrimary} from '@homeaway/react-buttons';
import Footer from '../Footer/Footer';
import AlertBox from '../Alert/Alert';
import InfoCard from '../Card/InfoCard';


export default class ConfirmationPage extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.triggerEdapPageViewAction();
    }

    getConfirmationPageContent() {
        const {translations, systemId, externalId} = this.props;

        return (
            <div className="confirmationcontent-pg-desc">
                <p> {translations['ipmob.confirmation.description_1']} </p>
                <p> {translations['ipmob.confirmation.description_2'].replace(/\[Advertiser\]/gi, systemId)} </p>
                <p> {translations['ipmob.confirmation.description_3'].replace(/\[Advertiser\]/gi, externalId)} </p>
                <p> {translations['ipmob.confirmation.description_4']} </p>
            </div>
        );
    };

    bankingConfirmationPage() {
        const {translations, systemId, externalId, brandData, businessModel, showChangeBusinessModel, showSwitchSoftwareProvider, handleContinueSubmit, handleBMXFlowSwitchSubmit, serviceError, handleAlertDismiss} = this.props;
        const brandImage = getBrandImageUrl(brandData.name);
        const flagImage = getFlagImageUrl(brandData.name);
        const businessModelKey = businessModel === MERCHANT_OF_RECORD.EXPEDIA? 'vrbo_model': 'agency_model';
        return (
            <div className="confirmation-pg-container">
                <div className="form-col">
                    {
                        serviceError
                            ? <div className="alert-panel">
                                <AlertBox
                                    messageKey={serviceError}
                                    translations={translations}
                                    handleAlertDismiss={handleAlertDismiss}
                                    size={'sm'}
                                />
                            </div>
                            : null
                    }
                    <div className="confirmation-pg">
                    <h1 className="confirmation-header">{translations["ipmob.confirmation.banking.heading"]}</h1>
                    <div className="confirmation-pg-content-container">
                        {showChangeBusinessModel && <div className="card action-card">
                            <div className="card-content-container">
                                <h1 className="head">{translations["ipmob.confirmation.banking.action_1.heading"]}</h1>
                                <p className="desc">{translations["ipmob.confirmation.banking.action_1.description"]}</p>
                                <ButtonPrimary
                                    className="action-card-button"
                                    label={translations["ipmob.confirmation.banking.action_1.button.label"]}
                                    id={'changeBusinessModel'}
                                    onClick={handleBMXFlowSwitchSubmit}
                                    disabled={false}
                                />
                            </div>
                        </div>}
                        {showSwitchSoftwareProvider && <div className="card action-card">
                            <div className="card-content-container">
                                <h1 className="head">{translations["ipmob.confirmation.banking.action_2.heading"]}</h1>
                                <p className="desc">{translations["ipmob.confirmation.banking.action_2.description"]}</p>
                                <ButtonPrimary
                                    className="action-card-button"
                                    label={translations["ipmob.confirmation.banking.action_2.button.label"]}
                                    id={'changeSoftwareProvider'}
                                    onClick={handleContinueSubmit}
                                    disabled={false}
                                />
                            </div>
                        </div>}
                    </div>
                </div>
                    <h1 className="confirmation-sub-header">{translations["ipmob.confirmation.banking.sub_heading"]}</h1>
                    <div className="confirmation-pg-content-container">
                        <div className="wrapper">
                            <div className="advertiser-info-col">
                                <h2 className="confirmation-label">{translations["ipmob.confirmation.banking.label_1"]}</h2>
                                <p className="confirmation-text"> {systemId} </p>
                                <h2 className="confirmation-label">{translations["ipmob.confirmation.banking.label_2"]}</h2>
                                <p className="confirmation-text"> {externalId} </p>
                                {businessModel && <div>
                                    <h2 className="confirmation-label">{translations[`ipmob.confirmation.banking.${businessModelKey}.label`]}</h2>
                                    <p className="confirmation-text">{translations[`ipmob.confirmation.banking.${businessModelKey}.description`]}</p>
                                 </div>
                                }
                            </div>
                            <div className="brand-info-col">
                                <ConfirmBrandButtonHolder
                                    enableContinueButton={false}
                                    handleContinueButtonClick={null}
                                    translations={translations}
                                    continueButtonId='confirmBrandButton'
                                    data={brandData}
                                    brandImage={brandImage}
                                    flagImage={flagImage}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="info-card-col">
                    <InfoCard className="confirmation-pg-info-card">
                        <h2 className="info-card-header">{translations["ipmob.confirmation.banking.info.heading"]}</h2>
                        <p className="info-card-text">{translations["ipmob.confirmation.banking.info.description"]}</p>
                        <div className="confirmation-pg-info-list">
                            <p className="info-card-text">{translations["ipmob.confirmation.banking.info.description.step_1"]}</p>
                            <p className="info-card-text">{translations["ipmob.confirmation.banking.info.description.step_2"]}</p>
                            <p className="info-card-text">{translations["ipmob.confirmation.banking.info.description.step_3"]}</p>
                        </div>
                    </InfoCard>
                </div>
            </div>
        );
    }

    confirmationPage() {
        const {translations, handleContinueSubmit} = this.props;

        return (
        <div className="page_content">
            <div className="panel-head">
                <h1 className="header"> {translations['ipmob.confirmation.heading']}</h1>
            </div>
            <div className="helpful-resources-wrapper">
                <p>{this.getConfirmationPageContent()}</p>
            </div>
            <div className="helpful-resources-wrapper">
                <ContinueButtonHolder
                    handleContinueButtonClick={handleContinueSubmit}
                    enableContinueButton
                    translations={translations}
                    continueButtonId={'confirmationPageContinueBtn'}
                />
            </div>
        </div>);
    }

    render() {
        const { showBankingConfirmationPage, footerData, translations} = this.props;

        return (
            <div className="confirmation-pg">
                <div className="confirmation-pg-wrapper container">
                    <img className={showBankingConfirmationPage? "confirmation-pg-bg-img-right" : "confirmation-pg-bg-img-left"}  src={backgroundImage()} />
                    {showBankingConfirmationPage ? this.bankingConfirmationPage() : this.confirmationPage()}
                </div>
                <Footer
                    translations={translations}
                    skipComponent={!showBankingConfirmationPage}
                    isLandingPage
                    footerData={footerData}
                />
            </div>
        );
    }

}
